export default __webpack_public_path__ + "static/media/Communication.c106db5f.svg";